import { connect } from 'react-redux';
import {ROUTES} from '../constants';
import {RedirectWithParameter} from '../components/pages/SearchQuizPage';

const mapStateToProps = (_,ownProps) => {
	return {
		...ownProps
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		redirect : ()=>{
			dispatch((dispatch, getState)=>{
				const {location } = getState();
				if(location.prev.type===ROUTES.SEARCH_QUIZ_QUERIED) return;
				dispatch({
					type : ROUTES.SEARCH_QUIZ_QUERIED,
					payload : {
						key : 'query',
						query : {
							word : ''
						}
					}
				});
			});
		}
	};
};

export default connect(mapStateToProps,mapDispatchToProps)(RedirectWithParameter);